import * as t from "io-ts";

export const ShadowV = t.intersection([
  t.type({
    color: t.union([t.string, t.null]),
    x: t.union([t.string, t.null]),
    y: t.union([t.string, t.null]),
    blur: t.union([t.string, t.null])
  }),
  t.partial({
    spread: t.union([t.string, t.null]),
    position: t.union([t.string, t.null])
  })
]);

export type Shadow = t.TypeOf<typeof ShadowV>;

export const ShadowTypeV = t.union([t.literal("text"), t.literal("box")]);

export type ShadowType = t.TypeOf<typeof ShadowTypeV>;

export const ShadowValueV = t.intersection([
  t.type({ shadows: t.array(ShadowV) }),
  t.partial({ style: t.string })
]);

export type ShadowValue = t.TypeOf<typeof ShadowValueV>;
